import React from 'react'

const CalApiContext = React.createContext({
    calApi: {},
    activeDate: '',
    setActiveDate: () => {},
    addCalendarContext: () => {}
})

export default CalApiContext
